export type FetchFn = typeof fetch;
export type ReplaceContentFn = (content: string) => void;
export type VariantenWechselDetails = {
    syan: string;
    colorId?: string;
    itemId?: string;
};

export const variantenWechselEvent = "ents:pdp:variant:changed";

export default class VariantenwechselLogic {
    private pathPrefix: string | null | undefined;
    private ajaxPath: string | null | undefined;
    private readonly replaceContentFn: ReplaceContentFn;
    private readonly fetchFn: FetchFn;

    constructor(replaceContentFn: ReplaceContentFn, fetchFn: FetchFn) {
        this.replaceContentFn = replaceContentFn;
        this.fetchFn = fetchFn;
    }

    private static fetchContent(
        pathPrefix: string | null | undefined,
        syan: string,
        farbId: string | undefined,
        artikelId: string | undefined,
        renderRoute: string | null | undefined,
        replaceContentFn: ReplaceContentFn,
        fetchFn: FetchFn,
    ): Promise<void> {
        if (!pathPrefix) {
            return Promise.reject(new Error("pathPrefix is required"));
        }
        if (!renderRoute) {
            return Promise.reject(new Error("RenderRoute is required"));
        }
        const path = pathPrefix + renderRoute;
        const searchParams = new URLSearchParams();
        if (syan) {
            searchParams.append("syan", syan);
        } else {
            return Promise.reject(new Error("Syan is required"));
        }
        if (farbId) {
            searchParams.append("farbId", farbId);
        }
        if (artikelId) {
            searchParams.append("artikelId", artikelId);
        }
        const params = searchParams.toString();
        const request = path + "?" + params;

        return fetchFn(request, {
            headers: {
                "cube-pb-force": "1",
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.text();
                } else {
                    return null;
                }
            })
            .then((content) => {
                if (content !== null) {
                    replaceContentFn(content);
                }
                return void 0;
            });
    }

    setPathPrefix(pathPrefix: string): void {
        this.pathPrefix = pathPrefix;
    }

    setAjaxPath(ajaxPath: string): void {
        this.ajaxPath = ajaxPath;
    }

    handleEvent(event: CustomEvent<VariantenWechselDetails>): Promise<void> {
        const syan = event.detail.syan;
        const farbId = event.detail.colorId;
        const artikelId = event.detail.itemId;
        return VariantenwechselLogic.fetchContent(this.pathPrefix, syan, farbId, artikelId, this.ajaxPath, this.replaceContentFn, this.fetchFn);
    }
}
